<template>
  <BaseLink
    ref="link"
    :disabled
    @click="onClick">
    <slot/>
  </BaseLink>
</template>

<script>
/**
 * @deprecated Use {@link BaseLink} directly with tracking-name prop.
 */
export default {}
</script>
<script setup>
import { ref } from 'vue'
import BaseLink from '@shared/components/BaseLink.vue'
import { useClickTracker, useTrackingLinkClick } from '@shared/composables/link.js'

const props = defineProps({
  targetName: {
    type: String,
    default: null,
    validator: (value, props) => !value || (!props.appEntryPoint && !props.eventLabel && props.data)
  },
  data: {
    type: Object,
    default: () => ({}),
    validator: (value, props) => Object.keys(value).length === 0 || (!props.appEntryPoint && !props.eventLabel && props.targetName)
  },
  disabled: {
    type: Boolean,
    default: null
  },

  // Props below are deprecated.
  appEntryPoint: {
    type: String,
    required: true,
    validator: value => ['homepage', 'website', 'signup'].includes(value)
  },
  eventLabel: {
    type: String,
    required: true
  }
})

const emit = defineEmits({
  click: (event) => event instanceof MouseEvent
})

const link = ref(null)
const onClick = props.targetName
  ? useClickTracker(
      () => props.targetName,
      'link',
      () => props.data,
      emit,
      () => link.value.link
    )
  : useTrackingLinkClick(
      () => props.appEntryPoint,
      () => props.eventLabel,
      emit,
      () => link.value.link
    )
</script>
